var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"partner-ship section"},[_c('h1',{staticClass:"partner-ship-title"},[_vm._v("PARTNERSHIP")]),_c('homePartnerVue',{attrs:{"showTitle":false,"showName":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }